<template>
  <v-container fluid>
    <page-header />

    <v-card class="mb-4">
      <v-card-text>
        <v-form ref="basicForm" @submit.prevent>
          <v-row class="ma-0">
            <v-col cols="12" sm="6" lg="4">
              <form-input label="brPrice" :fieldValue.sync="formData.br_price" type="number" prefix="HK$" required />
            </v-col>
          </v-row>
          <v-btn depressed elevation="0" class="ml-2 mb-4" color="primary" type="button" @click="save()" :loading="$store.getters.isLoading">{{
            $t('save')
          }}</v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import FormInput from '@/components/form/FormInput.vue'

export default {
  name: 'Setting',
  components: {
    FormInput,
  },
  data: vm => ({
    formData: {
      br_price: '',
      br_plan_id: -1,
    },
  }),
  methods: {
    async getBrPrice() {
      try {
        const { data } = await this.$Fetcher.GetPlans({
          filters: [
            { key: 'status', value: 'active' },
            { key: 'type', value: 'br' },
          ],
        })

        this.$set(this.formData, 'br_price', data[0].price)
        this.$set(this.formData, 'br_plan_id', data[0].id)
      } catch (err) {
        this.$common.error(err)
      } finally {
        this.$store.dispatch('setInitLoading', false)
      }
    },

    async save() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', {
          message: 'processing',
        })
        return
      }

      const valid = await this.$refs['basicForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', {
          message: 'required',
        })
        return
      }

      this.$store.dispatch('setLoading', true)

      try {
        await this.$Fetcher.UpdatePlan(this.formData.br_plan_id, {
          price: parseFloat(this.formData.br_price)
        })
        this.$store.dispatch('setDataIsUpdated', false)
        this.$store.dispatch('setLoading', false)
        this.$store.dispatch('toggleSnack', {
          type: 'success',
          message: 'message.saveSuccess',
          refresh: true,
        })
      } catch (err) {
        this.$common.error(err)
        this.$store.dispatch('setLoading', false)
        this.$store.dispatch('setAlert', {
          title: 'message.saveFail',
          message: err,
          type: 'error',
        })
      }
    },
  },

  async mounted() {
    this.$store.dispatch('setInitLoading', true)
    this.getBrPrice()
  },
}
</script>
